import { Grid, Typography } from '@mui/material'
import styled from '@emotion/styled'
import { TypographyVariant } from '../../constants/properties'

const NoAccessIcon = styled.img`
  width: 100px;
`

const NoModuleAccess = () => {
  return (
    <Grid
      container
      sx={{ flexDirection: 'column', alignItems: 'center', mt: 7 }}
    >
      <NoAccessIcon src="/access_denied.svg" alt="No Access Icon" />
      <Typography variant={TypographyVariant.H6} sx={{ mt: 3 }}>
        No Access!
      </Typography>
      <Typography variant={TypographyVariant.SUBTITLE2}>
        Please contact your manager.
      </Typography>
    </Grid>
  )
}

export default NoModuleAccess
